import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    IconButton,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { CardListRow } from '../cardListRow/cardListRow';

type AccordionCardProps = {
    open?: boolean;
    title?: string;
    stayExpandedOnDetailsClick?: boolean;
};

export const AccordionCard: FunctionComponent<
    PropsWithChildren<AccordionCardProps>
> = ({ open, title, children, stayExpandedOnDetailsClick }) => {
    const [expanded, setExpanded] = useState(open ?? false);

    if (open !== undefined && open !== expanded) {
        setExpanded(open);
    }

    return (
        <Accordion
            elevation={2}
            onClick={() => setExpanded(!expanded)}
            expanded={expanded}
            component={Card}
            sx={{
                p: 0,
                borderRadius: '8px !important',

                ...(expanded && {
                    borderRadius: '16px !important',
                }),

                transition: 'all 100ms linear',
            }}
        >
            <AccordionSummary
                sx={{
                    backgroundColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 'unset',
                    m: 0,

                    '& .MuiAccordionSummary-content': {
                        margin: 0,
                    },

                    '& .Mui-expanded': {
                        margin: 'unset',
                    },
                }}
                expandIcon={
                    <IconButton
                        aria-label={expanded ? 'Einklappen' : 'Ausklappen'}
                        sx={{
                            color: 'text.primary',
                            transition: 'transform 0.2s',
                        }}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                }
                aria-controls='panel-content'
                id='panel-header'
            >
                <CardListRow>
                    <Typography
                        sx={{
                            width: '100%',
                            fontWeight: 600,
                        }}
                    >
                        {title}
                    </Typography>
                </CardListRow>
            </AccordionSummary>
            <AccordionDetails
                onClick={(e) => {
                    if (stayExpandedOnDetailsClick) {
                        e.stopPropagation();
                    }
                }}
                sx={{
                    p: 0,
                }}
            >
                {children}
            </AccordionDetails>
        </Accordion>
    );
};
